export const CREATE_TOAST = "CREATE_TOAST";
export const DELETE_TOAST = "DELETE_TOAST";
export const SET_CURRENT_USER = "SET_CURRENT_USER";
